import ReportPage from "./report-page";
export default ReportPage;
